import { Getters } from 'vuex-smart-module';
import WarrantyState from './state';

export default class WarrantyGetters extends Getters<WarrantyState> {}
